module.exports = __webpack_public_path__ + "static/media/1023025.852d616e.png";